import { OrderbookStyleToggle } from './OrderbookStyleToggle';

export const OrderbookLiquidityLegend = () => {
	return (
		<div className="flex w-auto justify-between p-0">
			<OrderbookStyleToggle />
		</div>
	);
};
